import { IPageTabNavLink } from "../interfaces-and-types";

export const checkoutpaymentLink: IPageTabNavLink[] = [
    {
        name: 'Checkout and Payment Links',
        route: '',
    },
]